// University of Cincinnati's undergraduate majors on the Uptown campus
// (#2652). Read on 2026-10-01 from UC Admissions' official program finder
// (admissions.uc.edu/programs.html), whose data file lists every program with
// its college, degree, level and campus. Kept: undergraduate bachelor's
// programs on the Uptown Campus. Each major appears once per degree; its
// concentrations (e.g. Biological Sciences, Biomedical Studies; Secondary
// Education, Mathematics) are folded into it. Left out: Exploratory (an
// undecided start, not a major), associate degrees, UC Blue Ash, UC Clermont
// and online-only programs, minors, certificates, graduate programs. Degree
// codes are UC's own (BSAEROE, BSDES, BUP ...). Group notes quote the
// Deadlines page (the college file's `deadlines` source). The KB's majors
// list was the starting point; the official page wins.
const majors = {
    "slug": "university-of-cincinnati",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program UC Admissions lists for the Uptown campus in its official program finder, grouped by the college that offers it, with the degree code UC gives. Concentrations within a major are folded into the major. Associate degrees, regional-campus and online-only programs, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Carl H. Lindner College of Business",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Business Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Fashion Business",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Industrial Management",
                    "degree": "BSIM"
                },
                {
                    "name": "Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Insurance and Risk Management",
                    "degree": "BBA"
                },
                {
                    "name": "International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Operations Management",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                }
            ],
            "note": "Lindner programs often fill and usually close on or soon after the November 1 Early Action deadline; UC recommends applying by then.",
            "noteSource": "deadlines"
        },
        {
            "name": "College of Allied Health Sciences",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Advanced Medical Imaging Technology",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BSHS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Speech-Language Hearing Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Arabic Language and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry-ACS",
                    "degree": "BS"
                },
                {
                    "name": "Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Digital Media",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geosciences",
                    "degree": "BS"
                },
                {
                    "name": "Geosciences",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary",
                    "degree": "BIS"
                },
                {
                    "name": "International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Judaic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American, Caribbean, and Latino/a/x Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Arts",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Social Justice",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Design, Architecture, Art, and Planning",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BSARCH"
                },
                {
                    "name": "Art History",
                    "degree": "BAARTHIS"
                },
                {
                    "name": "Communication Design",
                    "degree": "BSDES"
                },
                {
                    "name": "Fashion Design",
                    "degree": "BSDES"
                },
                {
                    "name": "Fine Arts - Art",
                    "degree": "BFA"
                },
                {
                    "name": "Games and Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BSDES"
                },
                {
                    "name": "Interior Design",
                    "degree": "BSID"
                },
                {
                    "name": "Urban Planning",
                    "degree": "BUP"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BS"
                }
            ],
            "note": "DAAP programs often fill and usually close on or soon after the November 1 Early Action deadline; UC recommends applying by then.",
            "noteSource": "deadlines"
        },
        {
            "name": "College of Education, Criminal Justice, and Human Services",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BSED"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BSED"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Human Development & Community Engagement",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BSIT"
                },
                {
                    "name": "Middle Childhood Education",
                    "degree": "BSED"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BSED"
                },
                {
                    "name": "Software Application Development",
                    "degree": "BS"
                },
                {
                    "name": "Special Education",
                    "degree": "BSED"
                },
                {
                    "name": "Sport Administration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering & Applied Science",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BSAEROE"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BSAE"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSBME"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCHE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCOMPE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BSCS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BSCM"
                },
                {
                    "name": "Cybersecurity Engineering",
                    "degree": "BSCYBR"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Electrical Engineering Technology",
                    "degree": "BSEET"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSEVE"
                },
                {
                    "name": "Fire Science",
                    "degree": "BSFSET"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BSISE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "BSMET"
                }
            ],
            "note": "Engineering programs often fill and usually close on or soon after the November 1 Early Action deadline; UC recommends applying by then.",
            "noteSource": "deadlines"
        },
        {
            "name": "College of Medicine",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Medical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ],
            "note": "College of Medicine programs often fill and usually close on or soon after the November 1 Early Action deadline; UC recommends applying by then.",
            "noteSource": "deadlines"
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Bachelor of Science in Nursing",
                    "degree": "BSN"
                }
            ],
            "note": "Nursing often fills and usually closes on or soon after November 1, the BSN priority deadline; UC recommends applying by Early Action.",
            "noteSource": "deadlines"
        },
        {
            "name": "College-Conservatory of Music",
            "source": {
                "label": "UC Admissions, Majors and Programs (Uptown Campus, bachelor's)",
                "url": "https://www.admissions.uc.edu/programs.html"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA"
                },
                {
                    "name": "Ballet",
                    "degree": "BFA"
                },
                {
                    "name": "Bassoon",
                    "degree": "BM"
                },
                {
                    "name": "Clarinet",
                    "degree": "BM"
                },
                {
                    "name": "Classical Guitar",
                    "degree": "BM"
                },
                {
                    "name": "Commercial Music Production",
                    "degree": "BM"
                },
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Double Bass",
                    "degree": "BM"
                },
                {
                    "name": "Euphonium",
                    "degree": "BM"
                },
                {
                    "name": "Flute",
                    "degree": "BM"
                },
                {
                    "name": "French Horn",
                    "degree": "BM"
                },
                {
                    "name": "Harp",
                    "degree": "BM"
                },
                {
                    "name": "Harpsichord",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BM"
                },
                {
                    "name": "Media Production",
                    "degree": "BFA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Musical Theater",
                    "degree": "BFA"
                },
                {
                    "name": "Oboe",
                    "degree": "BM"
                },
                {
                    "name": "Organ",
                    "degree": "BM"
                },
                {
                    "name": "Percussion",
                    "degree": "BM"
                },
                {
                    "name": "Piano",
                    "degree": "BM"
                },
                {
                    "name": "Saxophone",
                    "degree": "BM"
                },
                {
                    "name": "Theater Design and Production",
                    "degree": "BFA"
                },
                {
                    "name": "Trombone",
                    "degree": "BM"
                },
                {
                    "name": "Trumpet",
                    "degree": "BM"
                },
                {
                    "name": "Tuba",
                    "degree": "BM"
                },
                {
                    "name": "Viola",
                    "degree": "BM"
                },
                {
                    "name": "Violin",
                    "degree": "BM"
                },
                {
                    "name": "Violoncello",
                    "degree": "BM"
                },
                {
                    "name": "Voice",
                    "degree": "BM"
                }
            ],
            "note": "CCM programs often fill and usually close on or soon after the November 1 Early Action deadline; UC recommends applying by then. Pre-screening materials are encouraged by November 15.",
            "noteSource": "deadlines"
        }
    ]
};

export default majors;
